import { render, staticRenderFns } from "./RecoverPass.vue?vue&type=template&id=26d303ff"
import script from "./RecoverPass.vue?vue&type=script&lang=js"
export * from "./RecoverPass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports